import * as React from 'react';
import Modal from '../../components/Modal';
import AlertForm, { AlertFormProps } from './AlertForm';

export type AlertModalProps = AlertFormProps;

export type AlertModalState = {
    visible: boolean;
};

export default class AlertModal extends React.Component<AlertModalProps, AlertModalState> {
    public state = {
        visible: true,
    };

    constructor(props: AlertModalProps) {
        super(props);

        this.handleModalClose = this.handleModalClose.bind(this);
    }

    public render() {
        const { onCancel: _, ...props } = this.props;
        return (
            <Modal showClose={true} onClose={this.handleModalClose} visible={this.state.visible} >
                <AlertForm {...props} onCancel={this.handleModalClose} />
            </Modal>
        );
    }

    private handleModalClose(): void {
        this.setState({ visible: false });
        this.props.onCancel();
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/Alerts/AlertModal.tsx